var style = {"z-number-badge":"z-number-badge","z-brand-theme-bitiba":"z-brand-theme-bitiba","z-brand-theme-2024-bitiba":"z-brand-theme-2024-bitiba","z-number-badge--variant-primary":"z-number-badge--variant-primary","z-number-badge--variant-cart":"z-number-badge--variant-cart"};

export { style as default };
//# sourceMappingURL=NumberBadge.module.scss.js.map
